import BodyText from 'LuxKit/Typography/BodyText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { FormattedMessage } from 'react-intl'
import { offerPageRoutes } from 'takeovers/utils/constants/takeoverRoutes'
import TriplePointTakeoverBackground from './components/TriplePointTakeoverBackground'
import TriplePointTakeoverBannerContent from './components/TriplePointTakeoverBannerContent'
import TriplePointTakeoverCampaignSubtitle from './components/TriplePointTakeoverCampaignSubtitle'
import TriplePointTakeoverHeroTitle from './components/TriplePointTakeoverHeroTitle'
import TriplePointTakeoverLogo from './components/TriplePointTakeoverLogo'
import TriplePointTakeoverTierIcon from './components/TriplePointTakeoverTierIcon'
import TriplePointTakeoverSearchBanner from './components/TriplePointTakeoverSearchBanner'
import TriplePointTakeoverSearchTileBanner from './components/TriplePointTakeoverSearchTileBanner'
import TriplePointTakeoverBannerDescription from './components/TriplePointTakeoverBannerDescription'

export const triplePointCampaignId = 'triple_points_july_2026'
export const triplePointsTakeoverId = 'societytriplepoints'
export const triplePointsEndDate = '2026-07-30' // No business rules, only display
export const triplePointsRoute = '/triple-points'

const societyTriplePointsTakeoverConfig: App.SiteTakeoverConfig = {
  id: triplePointsTakeoverId,
  verticals: new Set(['home', 'hotel', 'tours', 'cruise', 'experience']),
  offerTypes: new Set<App.OfferType>([
    'hotel',
    'tactical_ao_hotel',
    'bedbank_hotel',
    'direct_tour',
    'partner_tour',
    'connection_tour',
    'cruise',
    'experience',
  ]),
  campaignTags: new Set([triplePointCampaignId]),
  palette: 'default',
  backgroundElement: TriplePointTakeoverBackground,
  searchPage: {
    bannerContent: <TriplePointTakeoverSearchBanner />,
    tileBanner: <TriplePointTakeoverSearchTileBanner />,
  },
  offerPage: {
    bannerContent: <TriplePointTakeoverBannerContent />,
  },
  heroSection: {
    campaignId: triplePointCampaignId,
    title: <TriplePointTakeoverHeroTitle />,
    subtitle: <TriplePointTakeoverCampaignSubtitle
      viewOffersTo={triplePointsRoute}
    />,
    logo: <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'inverse',
    verticals: new Set(['home']),
    filters: [
      {
        label: <FormattedMessage
          id="2b7A3yNlLF8U3TQmFNTW"
          defaultMessage="Triple points"
          description="Filter label for triple points offers in the loyalty program section"
        />,
        value: triplePointCampaignId,
        type: 'campaignTag',
      },
      {
        label: <FormattedMessage
          id="Rc7Wd5d2gPsQJZnOXdaQ"
          defaultMessage="Dining & Drinks"
          description="Filter label for dining and drinks holiday type in the site takeover promotion"
        />,
        value: 'Dining & Drinks',
        type: 'holidayType',
      },
      {
        label: <FormattedMessage
          id="06Ex3Fq3hoeXFJik9Gtz"
          defaultMessage="Family Friendly"
          description="Filter label for family friendly holiday type in the site takeover promotion"
        />,
        value: 'Family Friendly',
        type: 'holidayType',
      },
    ],
  },
  siteWide: {
    banner: {
      description: <TriplePointTakeoverBannerDescription />,
      bannerAction: {
        to: triplePointsRoute,
        children: <BodyText variant="small">
          <FormattedMessage
            id="ulGaNEkE5KkKWvB85pa1"
            defaultMessage="View offers"
            description="Button text for the triple points site-wide banner linking to the page showing all triple point offers"
          />
        </BodyText>,
      },
      align: 'center',
      tabletAlign: 'center',
      logo: <TriplePointTakeoverTierIcon size="small" />,
      showOnHomePage: false,
      palette: 'inverse',
      exceptedRoutes: offerPageRoutes,
    },
  },
}

export default societyTriplePointsTakeoverConfig
